import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IStatus } from './status.component.interface';

@Component({
    selector: 'mlp-ng-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class StatusSharedComponent {
    @Input() status: IStatus;
}
